import { includes, filter, get } from 'lodash';

export const getIsos = (data) => get(data, 'items', []);

export const getSelectedIsos = (data, ids) =>
    filter(getIsos(data), (item) => includes(ids, get(item, 'name', '')));
